import React, { useEffect } from "react";
import { connect } from "react-redux";
import CardReport from "./CardReport";
import FilterDateReport from "./FilterDateReport";
import HeaderReport from "./HeaderReport";
import TabSeparationReport from "./TabSeparationReport";
import ChartReport from "./ChartReport";
import TableReport from "./TableReport";
import reportAction from "../../../store/actions/reportCampaignAction";
import typeCampaignCategorySelected from "./TypeCampaignCategorySelected";
import BrowserData from "./BrowserData";
import TableIP from "./TableIP";
import ReportIPS from "./ReportIPS";

const ComponentReport = ({
  campaignTypeCategorySelected,
  dateFrom,
  dateTo,
  eventDataChart,
  whichSeparationActive,
  getCampaignsReportWithCampaignType,
  getCampaignsDataChartWithCampaignType,
  getCampaignsDataSeparationWithCampaignType,
}) => {
  useEffect(() => {
    getCampaignsReportWithCampaignType({
      campaign_type: campaignTypeCategorySelected,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getCampaignsDataChartWithCampaignType({
      campaign_type: typeCampaignCategorySelected.ALL,
      event_data_chart: eventDataChart,
      date_from: dateFrom,
      date_to: dateTo,
    });
    getCampaignsDataSeparationWithCampaignType({
      campaign_type: campaignTypeCategorySelected,
      date_from: dateFrom,
      date_to: dateTo,
      separation: whichSeparationActive,
    });
  }, []);

  return (
    <>
      <div id="report-top-header-container" className="w-100 bg-secondary">
        <HeaderReport />
        <FilterDateReport />
        <CardReport />
      </div>
      <div
        id="report-chart-and-table-container"
        className="border border-success w-100 rounded my-3"
      >
        <TabSeparationReport />
        <ChartReport />
        <BrowserData />
        <ReportIPS />
        <TableReport />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    campaignTypeCategorySelected:
      state.reportCampaign.campaign_type_category_selected,
    dateFrom: state.reportCampaign.date_from,
    dateTo: state.reportCampaign.date_to,
    eventDataChart: state.reportCampaign.event_data_chart,
    whichSeparationActive: state.reportCampaign.which_separation_active,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCampaignsReportWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_REPORT_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignsDataChartWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_CHART_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
    getCampaignsDataSeparationWithCampaignType: (action) => {
      dispatch({
        type: reportAction.GET_CAMPAIGNS_DATA_SEPARATION_WITH_CAMPAIGN_TYPE,
        payload: action,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ComponentReport);
